import { h, Component } from 'preact';

class Blank extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    render() {
        const { body } = this.props;
        if (!body) {
            return null;
        }
        return (<div class='w-100 d-flex justify-content-center position-relative'>
            <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                {body}
            </div>
        </div>);
    }
}

export default Blank;